// extracted by css-extract-rspack-plugin
module.exports =  {"root":"FormColumns__root___e6ZQl","column":"FormColumns__column___t9bMH"};